<div class="feature-banner" *ngIf="isTrialAccount" [ngClass]="cssClasses">
  <span *ngIf="!hideScale">{{ "premium_feature_plans_repackaging_all" | localize }}</span>
  <span *ngIf="hideScale">{{ "premium_feature_plans_repackaging" | localize }}</span>
</div>
